// extracted by css-extract-rspack-plugin
export default {"attachmentCellRoot":"AttachmentCell_attachmentCellRoot__oj81Q"};